import {ChangeDetectionStrategy, Component, ElementRef} from "@angular/core";
import {Observable} from "rxjs";
import {FormControl} from "@angular/forms";

@Component({
  selector: '[intMultiTagFilterSelectControl]',
  template: `
    <int-default-input
      [showLabelTip]="false"
      [formControl]="formControl"
    ></int-default-input>
  `,
  styles: [`
    :host {
      padding: 1rem 1rem 1rem;
      --int-default-input-field-padding-top: 0!important;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntMultiTagFilterSelectControlComponent {
  formControl = new FormControl('');
  change$: Observable<string> = this.formControl.valueChanges;
}
